import React, { useState, useRef } from 'react';
import { useSelector } from 'react-redux';
import { ESTADOS, TIPO_BENEFICIO, BENEFICIADOS, TIPO_MONITOREOS } from 'constants/nombresCatalogos';
import { selectCatalogByName } from 'selectors/catalogos.selectors';
import moment from 'moment';
import { SelectorTipoDescarga, HeaderPage } from 'components';
import { MONITOREOS_MEDIOS_IMPRESOS } from 'constants/tipoMonitoreos';
import './MediosImpresos.scss';
import { TablaMonitoreo } from './components/TablaMonitoreo';
import { BuscadorMonitoreo } from './components/BuscadorMonitoreo';

moment.locale('esES');

function MediosImpresos() {
  const catEstados = useSelector(selectCatalogByName(ESTADOS));
  const catHallazgos = useSelector(selectCatalogByName(TIPO_MONITOREOS)); // <- antes hallazgosCat!!!
  const catTipoBeneficio = useSelector(selectCatalogByName(TIPO_BENEFICIO));
  const catBeneficiados = useSelector(selectCatalogByName(BENEFICIADOS));

  const [procesarTodo, setProcesarTodo] = useState(false);

  const catalogosStore = {};
  catalogosStore.catHallazgos = catHallazgos;
  catalogosStore.beneficiados = catBeneficiados;
  catalogosStore.catTipoBeneficio = catTipoBeneficio;
  catalogosStore.catEstado = catEstados;

  const [mainFilters, setMainFilters] = useState({});
  const seleccion = useRef({});

  const handleProcesarTodoChange = (valor) => {
    try {
      setProcesarTodo(valor);
    } catch (error) {
      console.log('Error: ', error);
    }
  };

  return (
    <div className="med-imp-container">
      <HeaderPage
        section="Monitoreos"
        title="Medios impresos"
        header="Selecciona al menos un campo para realizar la búsqueda."
      />
      <div>
        {/* contextHolder */}

        <div>
          <BuscadorMonitoreo onSearch={setMainFilters} />
          <TablaMonitoreo
            mainFilters={mainFilters}
            seleccion={seleccion}
            onProcesarTodoChange={handleProcesarTodoChange}
          />
        </div>
        <SelectorTipoDescarga
          seleccion={seleccion}
          tipoMonitoreo={MONITOREOS_MEDIOS_IMPRESOS}
          tipoActa={null}
          procesarTodo={procesarTodo}
        />
      </div>
    </div>
  );
}

export default MediosImpresos;
